<template>
  <v-container pl-0 pr-0 align-start>
    <v-layout column>
      <div class="l-row ml-5">
        <child-clip :child="child"></child-clip>
      </div>
      <div class="l-row" ref="container"
        @transitionend="onTransitionEndContainer($event)">
        <v-expansion-panel>
          <v-expansion-panel-content
            lazy hide-actions
            v-for="q in assessment.questions" :key="q.qNo">
            <div slot="header">
              <span>{{ q.qNo }}</span>
              <span class="ml-2">{{ $t(q.topic) }}</span>
              <v-icon color="green" dark class="header-status-icon"
                v-if="answers[q.answerField] !== undefined">
                check_circle
              </v-icon>
              <v-icon color="grey" class="header-status-icon"
                v-else>
                more_horiz
              </v-icon>
              <div class="header-status-text"
                v-if="answers[q.answerField] !== undefined">
                <span class="grey--text" v-if="answers[q.answerField]">
                  {{ $t('ASS_ANS_Y') }}
                </span>
                <span class="grey--text" v-else>
                  {{ $t('ASS_ANS_N') }}
                </span>
              </div>
            </div>
            <div class="brown lighten-5 pa-4 pt-5 pb-5">
              <v-card class="white">
                <video class="responsive-video d-block mh-auto" controls v-if="q.videoURL" :poster="q.videoPosterURL">
                  <source :src="q.videoURL"/>
                </video>
                <v-card-text>
                  <h2>{{ q.qNo }} {{ $t(q.topic.trim()) }}</h2>
                  <div v-html="$t(q.qText.trim())"></div>
                  <div v-if="$t(q.notes.trim()) !== ''" v-html="$t(q.notes.trim())" class="mt-4"></div>
                </v-card-text>
                <!-- answerField -->
                <v-card-actions class="border-top ass-actions" v-if="!readOnly">
                  <v-radio-group v-model="answers[q.answerField]" row hide-details
                    class="ass-ans-radio-group">
                    <v-radio :label="$t('ASS_ANS_Y')" :value="true"></v-radio>
                    <div class="v-divider">|</div>
                    <v-radio :label="$t('ASS_ANS_N')" :value="false"></v-radio>
                  </v-radio-group>
                </v-card-actions>
              </v-card>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </div>
      <div class="l-row" v-if="!readOnly">
        <v-btn dark color="primary" class="right mr-5" @click="submitAnswers">
          {{ $t('LBL.SUBMIT_ANSWERS') }}
          <v-icon>play_arrow</v-icon>
        </v-btn>
      </div>
      <div class="l-row ass-result ma-2 mt-4 mb-4" v-if="readOnly">
        <v-card class="white">
          <v-card-text @click.stop="onResultPage"
            v-html="$t('TXT.ASS_REVIEW_PAGE_RESULT_HTML', {CHILD_FNAME: child.firstName, LIKELIHOOD: $t(likelihoodText).toUpperCase()})">
          </v-card-text>
          <v-card-actions class="theme--dark primary" >
            <v-btn flat @click="goToResources">{{ $t('LBL.RESOURCES') }}</v-btn>
            <v-btn flat to="/home">{{ $t('LBL.MY_ASSESSMENTS') }}</v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from 'vue'
import { mapMutations, mapActions } from 'vuex'
import {
  ENQUEUE_SNACKBAR
} from '@/store/mutation-types'
import ServerErrorMixin from '@/components/mixins/ServerErrorMixin'
import ChildClip from '@/components/elements/ChildClip'

function getCoords (elem) { // crossbrowser version
  const box = elem.getBoundingClientRect()

  const body = document.body
  const docEl = document.documentElement

  const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop
  const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft

  const clientTop = docEl.clientTop || body.clientTop || 0
  const clientLeft = docEl.clientLeft || body.clientLeft || 0

  const top = box.top + scrollTop - clientTop
  const left = box.left + scrollLeft - clientLeft

  return { top: Math.round(top), left: Math.round(left) }
}

export default {
  name: 'AssessmentContent',
  components: {
    'child-clip': ChildClip
  },
  computed: {
    likelihoodText () {
      return this.answers.atRisk
        ? 'LBL.HIGHER'
        : 'LBL.LOWER'
    }
  },
  created () {
    let _answers = {}
    console.log('originalAnswers', this.originalAnswers)
    if (this.originalAnswers) {
      _answers = Object.assign({}, this.originalAnswers)
      Object.keys(_answers).forEach(key => {
        const val = _answers[key]

        if (val === 'Atypical') {
          _answers[key] = false
        } else if (val === 'Typical') {
          _answers[key] = true
        }
      })
    }

    this.answers = Object.assign({}, _answers)

    const videoURLs = this.$i18n.t(`ASS${this.assessment.age}_VIDEO_URLS`).split(';')
    const videoPosterURLs = this.$i18n.t(`ASS${this.assessment.age}_VIDEO_POSTER_URLS`).split(';')

    this.assessment.questions.forEach((q, i) => {
      q.videoURL = videoURLs[i] || ''
      q.videoPosterURL = videoPosterURLs[i] || ''
    })
  },
  data () {
    return {
      answers: {}
    }
  },
  methods: {
    submitAnswers () {
      const assData = Object.assign({}, this.answers)

      if (Object.keys(assData).length !== this.assessment.questions.length) {
        this.showMessage({
          text: this.$i18n.t('MSG.PLEASE_ANSWER_ALL_QUESTIONS_FIRST'),
          color: 'error'
        })
        return
      }
      Object.keys(assData).forEach(key => {
        assData[key] = assData[key] ? 'Typical' : 'Atypical'
      })

      assData.childId = this.child.id
      assData.consultationDate = new Date().toISOString().substr(0, 10)

      const assessmentName = this.assessment.name
      console.log('assessmentName', assessmentName, 'assData', assData)

      this.doSubmit({assessment: this.assessment, assData})
        .then((resp) => {
          this.$router.push({
            name: 'AssessmentResultPage',
            params: {
              childId: this.$route.params.childId,
              age: this.$route.params.age,
              result: resp.data.data.atRisk ? 2 : 1
            }
          })

          this.showMessage({
            text: this.$i18n.t('MSG.ASSESSMENT_SUBMITTED_SUCCESS', {ASSES_NAME: this.$i18n.t(assessmentName)}),
            color: 'success'
          })
        })
        .catch((error) => {
          console.log('api error', error)
          this.showMessage({
            text: this.$i18n.t(this.getErrorMessage(error) || 'MSG.SYSTEM_ERROR_RETRY'),
            color: 'error'
          })
        })
    },
    onTransitionEndContainer (event) {
      const el = event.target
      if (!el.classList.contains('expansion-panel__container--active')) {
        return
      }

      const toolbarHeight = document.querySelector('.header-toolbar').offsetHeight

      if (el.scrollIntoView) {
        setTimeout(() => {
          el.scrollIntoView(true)

          // now account for fixed header
          const doc = document.documentElement
          const windowTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)

          if (windowTop) {
            window.scroll(0, windowTop - toolbarHeight)
          }
        }, 50)
      } else {
        Vue.nextTick(() => {
          setTimeout(() => {
            const coords = getCoords(el)

            const doc = document.documentElement
            const windowLeft = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0)
            const windowTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)
            if (coords.top !== windowTop) {
              window.scrollTo(windowLeft, (coords.top - toolbarHeight) || 0)
            }
          }, 50)
        })
      }
    },
    goToResources () {
      window.open('http://asdetect.org/')
    },
    onResultPage (e) {
      if (e.target.innerText.match(/^(\w+) likelihood$/i)) {
        this.$router.push({
          name: 'AboutUsPage',
          hash: '#high-low'
        })
      }
    },
    ...mapMutations({
      showMessage: ENQUEUE_SNACKBAR
    }),
    ...mapActions({
      doSubmit: 'submitAssessment'
    })
  },
  mixins: [
    ServerErrorMixin
  ],
  props: {
    child: {
      type: Object,
      default: () => ({})
    },
    assessment: {
      type: Object,
      default: () => ({})
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    originalAnswers: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/styles/_colors.scss';

.header-status-text {
  display: block;
  float: right;
  text-transform: uppercase;
  line-height: 24px;
  margin-right: 8px;
  font-size: 12px;
  color: $grey-base;
  font-weight: bolder;
}

.header-status-icon {
  width: 24px;
  display: block;
  float: right;
}

.expansion-panel__container {
  background-color: #fff!important;
}

.ass-actions {
  .ass-ans-radio-group {
    width: 100%;
    text-align: right;

    padding: 2px;

    @include mq('md') {
      padding: 8px;
    }

    & /deep/ {
      > .input-group__input {
        display: inline-block;
      }
    }

    .input-group--selection-controls  {
      display: inline-block;
      width: auto;

      & /deep/ {
        label {
          max-width: none;
          width: auto;
          position: static;
          margin-left: 30px; // width of radio
          vertical-align: middle;
          text-transform: uppercase;
        }

        .input-group__input {
          display: inline-block;
          position: absolute;
          left: 0;
        }
      }
    }

    .v-divider {
      font-size: 16px;
      display: inline-block;
      margin-left: 10px;
      margin-right: 10px;
      line-height: 30px;
    }
  }
}

.ass-result {
  .card__text /deep/ {
    u, strong {
      color: $amber-darken4 !important;

      .lang-zh & {
        color: $blue-darken2 !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/elements/AssessmentContent.vue